import load from './loadScript';

/**
 * @param {string} name
 * @param {Element} mountPoint
 * @param {Object} options
 * @return {Function}
 */
function renderApp(name, mountPoint, options) {
    const runName = `run${name}`;
    const runFn = window[runName] || (() => () => null);

    return runFn(mountPoint, options ?? {});
}

/**
 * @param {string} name
 * @param {string} url
 * @param {Element} mountPoint
 * @param {Object} options
 * @return {Promise<Function>} Resolves to be the unmount function
 */
export default async function mountMicroFrontend(name, url, mountPoint, options) {
    const scriptId = `micro-frontend-script-${name}`;
    if (document.getElementById(scriptId)) {
        return renderApp(name, mountPoint, options);
    }

    const response = await fetch(`${url}/asset-manifest.json`);

    if (!response.ok) {
        throw new Error(`MicroFrontend: Invalid response when fetching manifest for ${name} (${response.status})`);
    }

    const manifest = await response.json();
    const fileMap = manifest.files;

    // eslint-disable-next-line no-console
    console.log('Load micro frontend', { name, url, options, manifest });

    const chunkPromises = Object
        .entries(fileMap)
        .map(([filename, path]) => {
            try {
                const id = filename === 'main.js' ? scriptId : undefined;
                return load.any(path, { id });
            } catch (e) {
                return Promise.resolve('');
            }
        });

    await Promise.all(chunkPromises);

    return renderApp(name, mountPoint, options);
}
